const Style = {

  row:   'flex gap-5 mb-5',
  card:  'flex-1 border rounded-xl px-6 py-5 flex items-center justify-between',
  label: 'text-sm text-gray-700 font-medium mb-2',
  count: 'text-3xl font-bold leading-none',

  // Per-sentiment colour variants applied to card and count
  positive:      'bg-green-50 border-green-200',
  positiveCount: 'text-green-600',
  neutral:       'bg-yellow-100 border-amber-200',
  neutralCount:  'text-yellow-600',
  negative:      'bg-red-50 border-red-200',
  negativeCount: 'text-red-600',

}

export default Style;
